import { create } from 'zustand'
import { devtools, persist } from 'zustand/middleware'

/**
 * Survey UI State Interface
 * Manages UI state for survey-related components
 */
interface SurveyUIState {
  // Expandable states for different survey flows
  expandableStates: Record<string, boolean>
  
  // Actions
  setExpandableState: (key: string, isExpanded: boolean) => void
  toggleExpandableState: (key: string) => void
  clearExpandableStates: () => void
}

const initialState = {
  expandableStates: {},
}

export const useSurveyStore = create<SurveyUIState>()(
  devtools(
    persist(
      (set) => ({
        ...initialState,

        /**
         * Set the expandable state for a specific key
         * Used to persist UI state across navigation
         */
        setExpandableState: (key: string, isExpanded: boolean) => {
          set((state) => ({
            expandableStates: {
              ...state.expandableStates,
              [key]: isExpanded,
            },
          }))
        },

        /**
         * Toggle the expandable state for a specific key
         */
        toggleExpandableState: (key: string) => {
          set((state) => ({
            expandableStates: {
              ...state.expandableStates,
              [key]: !state.expandableStates[key],
            },
          }))
        },

        /**
         * Clear all expandable states
         * Used when starting fresh or clearing UI state
         */
        clearExpandableStates: () => {
          set({ expandableStates: {} })
        },
      }),
      {
        name: 'survey-store',
        partialize: (state) => ({
          expandableStates: state.expandableStates,
        }),
      }
    ),
    { name: 'survey-store', enabled: import.meta.env.DEV }
  )
) 